import { Editor, Element as SlateElement, Transforms } from 'slate';

type StyledElement = SlateElement & {
  styleName?: string;
};

const ALIGNMENT_CLASSES = [
  'text-left',
  'text-center',
  'text-right',
  'text-justify',
];

export const isStyleActive = (
  editor: Editor,
  style: string,
): boolean => {
  const matches = Array.from(
    Editor.nodes(editor, {
      match: (node) => {
        if (!SlateElement.isElement(node)) {
          return false;
        }

        const element = node as StyledElement;

        return !!(
          element.styleName &&
          element.styleName.split(' ').includes(style)
        );
      },
    }),
  );

  return matches.length > 0;
};

export const toggleStyle = (
  editor: Editor,
  style: string,
): void => {
  const active = isStyleActive(editor, style);

  const nodes = Array.from(
    Editor.nodes(editor, {
      mode: 'highest',
      match: (node) => !Editor.isEditor(node),
    }),
  );

  for (const [node, path] of nodes) {
    const element = node as StyledElement;

    let classes = (element.styleName || '')
      .split(' ')
      .filter(Boolean);

    // remove existing alignment classes
    classes = classes.filter(
      (className) =>
        !ALIGNMENT_CLASSES.includes(className),
    );

    // add selected style if not already active
    if (!active) {
      classes.push(style);
    }

    Transforms.setNodes<StyledElement>(
      editor,
      {
        styleName: classes.join(' '),
      },
      { at: path },
    );
  }
};